import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import { ErrorState } from '../store/errorState';

const initialState: ErrorState = {
  loadingErrors: [],
};

export function errorsReducer(state: ErrorState = initialState, action: AllActions): ErrorState {
  switch (action.type) {
    case InternalActionTypes.RequestLoadingError:
      return {
        ...state,
        loadingErrors: state.loadingErrors.concat({
          message: action.error ? action.error.message : null,
          component: action.component,
        }),
      };
    default:
      return state;
  }
}
